/** @format */
import { css } from 'styled-components';

import { ColumnProps } from './index';

/**
 * Base styles for the column component
 */
const baseStyles = css``;

/**
 * The column component styles
 *
 * @param {ColumnProps} props The column properties object
 * */
export const styles = (props: ColumnProps) => css`
    ${baseStyles}
`;
